import {
    CHANGE_ID,
    CHANGE_PASS,
    CHANGE_IS_ERR,
    CHANGE_IS_LOGIN
} from './actions';

const initData = {
    id: '',
    pass: '',
    isErr: false,
    isLogin: true
};

export function userReducer(state = initData, action) {
    switch (action.type) {
        case CHANGE_ID:
            return changeIdReduce(state, action);
        case CHANGE_PASS:
            return changePassReduce(state, action);
        case CHANGE_IS_ERR:
            return changeIsErrReduce(state, action);
        case CHANGE_IS_LOGIN:
            return changeIsLoginReduce(state, action);
        default:
            return state;
}
}

export function changeIdReduce(state, action) {
    return {
        ...state,
        id: action.id
    };
}

export function changePassReduce(state, action) {
    return {
        ...state,
        pass: action.pass
    };
}

export function changeIsErrReduce(state, action) {
    return {
        ...state,
        isErr: action.isErr
    };
}

export function changeIsLoginReduce(state, action) {
    return {
        ...state,
        isLogin: action.isLogin
    };
}